interface ChildSafetyPolicyTextTextProps {
    system?: string;
}

const ChildSafetyPolicyText = ({ system = "Paçoca" }: ChildSafetyPolicyTextTextProps) =>{
    return (
        <div style={{textAlign: "justify"}}>
            <p>Última atualização: 12/09/2024</p>

            <h5>Política de Segurança Infantil e Proteção contra CSAE – {system}</h5>

            <p>
            A <strong>{system}</strong> possui <strong>tolerância zero</strong> a qualquer forma de 
            <strong>abuso e exploração sexual infantil (CSAE)</strong>.
            </p>

            <p>
            É <strong>estritamente proibido</strong> utilizar a {system} para criar, publicar,
            compartilhar, armazenar ou promover qualquer conteúdo que envolva crianças ou
            adolescentes de forma sexual, explícita ou sugestiva.
            </p>

            <p>A {system} proíbe explicitamente:</p>

            <ul>
            <li>Abuso sexual de crianças ou adolescentes;</li>
            <li>Exploração sexual infantil;</li>
            <li>Nudez ou conteúdo sexual envolvendo menores;</li>
            <li>Conteúdos fictícios, ilustrados, animados ou escritos com teor sexual envolvendo menores;</li>
            <li>Aliciamento, grooming ou assédio sexual de menores;</li>
            <li>Qualquer tentativa de contato sexual com menores.</li>
            </ul>

            <p>
            A <strong>{system} monitora, detecta e remove</strong> imediatamente conteúdos que violem
            esta política.
            </p>

            <p>
            Contas envolvidas serão <strong>suspensas ou banidas permanentemente</strong>, sem aviso prévio.
            </p>

            <p>
            Quando aplicável, a <strong>{system} reportará conteúdos e usuários às autoridades competentes</strong>,
            em conformidade com a legislação vigente.
            </p>

            <p>
            Usuários podem denunciar conteúdos ou comportamentos suspeitos diretamente pelo aplicativo
            ou pelo e-mail:
            <a href="mailto:pacocaredesocial@gmail.com">pacocaredesocial@gmail.com</a>.
            </p>

        </div>
    )
}

export default ChildSafetyPolicyText;
